'use client';

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from 'react';
import { type FeatureGateName, featureGates } from '@/config/feature-gates';
import { checkGate, getProviderReady, subscribeProviderReady } from '@/lib/analytics';
import { getGateValuesPending, getGateValuesVersion, subscribeGateValues } from '@/lib/analytics/gate-values';
import { getDevToolkitAccess, subscribeDevToolkitAccess, useDevToolkitStore } from '@/stores/dev-toolkit';

/**
 * Resolves a feature gate only after the analytics provider has fresh values.
 * `null` means the provider is still loading — or an identity update is in
 * flight, so the current evaluation is the anonymous user's; callers must
 * preserve pending actions such as deep-link parameters until the value
 * becomes boolean. Re-renders when settled values change (post sign-in).
 */
export function useFeatureGate(name) {
  const $ = _c(4);
  let t0;
  if ($[0] !== name) {
    t0 = state => state.overrides[name];
    $[0] = name;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const localOverride = useDevToolkitStore(t0);
  const devToolkitAccess = useSyncExternalStore(subscribeDevToolkitAccess, getDevToolkitAccess, _temp);
  const providerReady = useSyncExternalStore(subscribeProviderReady, getProviderReady, _temp2);
  useSyncExternalStore(subscribeGateValues, getGateValuesVersion, _temp3);
  const identityPending = useSyncExternalStore(subscribeGateValues, getGateValuesPending, _temp4);
  const hasAccessibleOverride = devToolkitAccess && localOverride !== undefined;
  const waitsForIdentity = featureGates[name]?.idType !== "stableID";
  if ((!providerReady || identityPending && waitsForIdentity) && !hasAccessibleOverride) {
    return null;
  }
  let t1;
  if ($[2] !== name) {
    t1 = checkGate(name);
    $[2] = name;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp4() {
  return false;
}
function _temp3() {
  return 0;
}
function _temp2() {
  return false;
}
function _temp() {
  return false;
}